export default __webpack_public_path__ + "static/media/02.75cfc55f.png";